import { Components } from '@mui/material/styles';
import { Theme } from '@mui/material';

export const flowAccordionDetails: Components<Theme>['MuiAccordionDetails'] = {
  defaultProps: {},
  styleOverrides: {
    root: {
      // proportions
      padding: '0',
      '&:last-of-type': {
        paddingBottom: '22px',
      },
    },
  },
};
